import React, {Component, lazy, Suspense} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Trans} from '@lingui/macro';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isNumber from 'lodash/isNumber';
import {v1 as uuidv1} from 'uuid';
import xssFilters from 'xss-filters';
import FloatingActionButton from '../FloatingActionButton';
import Header, {FullPageHeader} from '../Header';
import Breadcrumbs from '../Breadcrumbs';
import PopupText from '../PopupText';
import log from 'loglevel';
import LoadingSpinner from '../LoadingSpinner';
import ConfirmModal from '../ConfirmModal';
// import _ from 'lodash';
import {
  isNotEmptyArray,
  isObjectEmpty,
  stringJoinWordsWithDashes,
  fetchLinkToMapping,
  hasChatInPrevPage,
} from '../../utils/utilFunctions';
import {
  adpAnalyticsLog,
  buildAdpAnalyticsPayload,
  setAdobeAnalyticsValue,
  forgeSignIntoAnotherAccount,
  isStorageAccessible
} from '../../utils';
import {getUserEntitlementLevel, getIsPowerUser} from '@adsk/ha-entitlements-util';
import {withLDConsumer} from 'launchdarkly-react-client-sdk';
//import {hasChatInPrevPage} from '@adsk/dh-contact-react-components/InlineChat/util';
import ThemeMui from '@digital-hig/theme-mui';

// redux action creators
import {
  updateHeaderReloadAndBack,
  updateUHComponentShowingNow,
  updateContentSuggUserInput,
  updateSelectedProduct,
  updateSelectedVersion,
  toggleUserInput,
  fetchWorkflow,
  fetchProductReleases,
  updateCurrentGuid,
  updateHasBeedRedirected,
  updateSeenGuids,
  toggleMainWindowAndFab,
  updateUserInteracted,
  updateCurrentPrompt,
  updateSkillsResponse,
  updateSuggestedArticles,
  updateSuggestedArticleType,
  updateExceptionMsg,
  updateDefaultSupportSkill,
  updateResolvedSupportSkill,
  updateSfdcType,
  updateSfdcTopic,
  updatePremiumSupportSkill,
  updatePremiumSfdcType,
  updatePremiumSfdcTopic,
  toggleAvaLoading,
  showAvaModal,
  closeAvaModal,
  updateShowContactFooter,
  updateDefaultEscapeActionGuid,
  updateShowContactDetailsInAction,
  updateHideTopicNotListed,
  updateHideContactModalities,
  updateShowResellerContactModality,
  updateCurrentTopLevelBranch,
  disableNavBtns,
  togglePopUpMainWindow,
  toggleLoginHappening,
  updateContactAppLoading,
  quickToggleShowPhoneFooter,
  toggleShowFeedbackWidgetFlow,
  updateUserContext,
  updateShowModal,
  updateHideSecondaryNav,
  updateShowAdditionalQuestionsPage,
  updateOpenUHMThroughLink,
  updateContextualLinkOrigin,
  updatelinkToADNSupportPage,
  updateResetToHome,
  updateIsChatActive,
  updateIsEndChatThroughButton,
  updateUhmSubHeaderType,
  updateSaveChatTrigger,
  updateSettingsSiteData,
  updateEndChatTrigger,
  updateShowOverlayComponent,
  updateHasInstructionalText,
  updateUserInputFromAva,
  // updateShowAgentAvailabilityComponent,
  updateShowAgentAvailabilityFallbackComponent,
  updateShowAnythingElseComponent,
  updateShowPhoneHourBubbleComponent,
  updateAnythingElseEndChat,
  updateSubOrigin,
  updateDeepLinkCAEduFlow,
  updateContainerEventMessage,
  updateOpenAferRedirect,
  updateRequestId,
  updateSessionTokenAvailable
} from '../../actions';
import {
  DISAMBIGUATION_QUESTIONS,
  CONTACT_OPTIONS,
  CONTENT_SUGGESTION,
  CAAS_CONTENT,
  actionsMap,
  analyticsLabelMap,
  siteTierConfig,
  LINKS,
  AVA,
  FAIL_SCREEN,
  CONTACT_OPTION_CASE,
  CONTACT_OPTION_SCHEDULER,
} from '../../app.config';

import './_UniversalHelp.scss';
import './_RosettaThemeOverrides.scss';
const UniversalHelpBody = lazy(() => import('./UniversalHelpBody'));

// default start guid
const START_GUID = 'start';

// chat session function
const {hasCurrentChatSession} = hasChatInPrevPage();
const isLocalStorageAvailable = isStorageAccessible(() => localStorage);
const isSessionStorageAvailable = isStorageAccessible(() => sessionStorage);

class UniversalHelp extends Component {
  // load initial state
  constructor(props) {
    super(props);

    const {
      showFullPage,
      product,
      integrationType,
      mode
    } = this.props.siteData;

    this.state = {
      showMainWindow:
        (product !== 'NINVFUS' && mode === 'open' && integrationType === 'In-Product') ? false :
        showFullPage ||
        (this.props.flags.tempInlineChatExperience
          ? hasChatInPrevPage().hasCurrentChatSession
          : '')
          ? true
          : ['openWidget' , 'open'].includes(mode) ||
            this.props.popUpMainWindow, // state UHM as closed on init.
      fail: false,
      showWelcomePopUp: true,
      showContextualPopUp: true,
      windowIsClosing: false,
    };
  }

  // on first load go to start
  async componentDidMount() {
    const {
      workflowData,
      workflowViaProp,
      siteData,
      popUpMainWindow,
      togglePopUpMainWindow,
      currentGuid,
      componentShowingInUH,
      // fetchProductReleases,
      fetchWorkflow,
      currentTopLevelBranch,
      updateContactAppLoading,
      componentData,
      updateUHComponentShowingNow,
      flags: launchDarklyFlags,
      ldClient,
      updateHasBeedRedirected,
      startGuid,
      updateIsChatActive,
      contextualLinkOrigin,
      openAfterRedirect,
      updateOpenAferRedirect,
      updateSettingsSiteData,
      updateRequestId,
      requestId,
      userDetails,
      updateUhmSubHeaderType
    } = this.props;

    let uhmLoadedRequestID = requestId

    // reset request ID on load, but NOT if redirecting after login or account switch
    if (!openAfterRedirect) {
      updateRequestId(null)
      uhmLoadedRequestID = null
    }

    /**
     * delay automatic opening of UHM from iph insights' "Try it now" cta
     */
    if (userDetails.userid && launchDarklyFlags.permanentShouldShowUa) {
      this.autoOpenUaWithDelay();
    }

    // increment or set session storage page count to 1
    if (isSessionStorageAvailable) {
      const sessionStoragePageCount = parseInt(
        window.sessionStorage.getItem('numArticlesSeen')
      );
      window.sessionStorage.setItem(
        'numArticlesSeen',
        sessionStoragePageCount ? sessionStoragePageCount + 1 : 1
      );
    }

    const {showFullPage = false, language, product, integrationType, mode} = siteData;
    let additionalAdpData = {};
    if (integrationType === 'In-Product' && product !== 'NINVFUS') {
      const newFlowId = uuidv1();
      updateSettingsSiteData({
        ...siteData,
        flowId: newFlowId,
      });
      additionalAdpData = {cm_flow_id: newFlowId};
    }

    //ADP event on UHM load
    adpAnalyticsLog(
      buildAdpAnalyticsPayload({
        e: 'uhm_loaded',
        ev: true,
        cm_cs_request_id: uhmLoadedRequestID,
        ...additionalAdpData,
      })
    );

    window.parent.postMessage(
      {type: 'UHM_LOADED'},
      this.props.siteData.pageDomain || 'localhost.autodesk.com:3000'
    );
    
    // Mark UHM initialization as complete to stop error reporting
    window.__uhmInitComplete = true;

    updateContactAppLoading(true);

    const experimentUrl = siteTierConfig.experimentSitesConfigUrl;
    // cross script checking
    const expDecisionTreeTesting = xssFilters.uriQueryInUnQuotedAttr(
      launchDarklyFlags?.expDecisionTreeTesting?.DTName
    );

    const {showMainWindow} = this.state;

    if (popUpMainWindow) {
      togglePopUpMainWindow(false);
    }
    if (ldClient) {
      ldClient.track('shownDT');
    }

    if (isObjectEmpty(workflowData) && isObjectEmpty(workflowViaProp)) {
      // get workflow
      if (expDecisionTreeTesting && expDecisionTreeTesting !== 'control') {
        // Experiment URL
        const fetchExperimentWorkflowUrl = `${experimentUrl}/${expDecisionTreeTesting}${
          showFullPage ? '_akn_' : '_'
        }${language}_${product === '' ? 'generic' : product}.json`;
        await fetchWorkflow(
          fetchExperimentWorkflowUrl,
          workflowViaProp,
          siteData.workflowJson // This is the fallback workflow
        );
      } else {
        await fetchWorkflow(siteData.workflowJson, workflowViaProp);
      }
    }
    if (
      [CONTACT_OPTION_SCHEDULER, CONTACT_OPTION_CASE].includes(
        componentShowingInUH
      ) &&
      isEmpty(siteData.linkToModality)
    ) {
      updateUHComponentShowingNow(DISAMBIGUATION_QUESTIONS);
      this.resetStates();
    }

    // Deep linking solution
    if (
      (showFullPage &&
        !isEmpty(siteData.linkTo) &&
        !isEmpty(siteData.linkToModality) &&
        (siteData.linkToModality === 'case' ||
          siteData.linkToModality === 'scheduler')) ||
      (!isEmpty(siteData.linkTo) && !siteData.hasBeenRedirected)
    ) {
      // Resets UI when user has previously visited UHM
      if (componentShowingInUH !== DISAMBIGUATION_QUESTIONS) {
        updateUHComponentShowingNow(DISAMBIGUATION_QUESTIONS);
        this.resetStates();
      }
      const {parents = []} = siteData.linkTo;
      //resets seen guids before deep linking user
      await updateSeenGuids([], startGuid);
      isEmpty(siteData.linkToModality) && updateHasBeedRedirected(); //prevents linkTo to the same branch after 1st redirect
      await this.handleDeepLinks(siteData.linkTo.key, parents);
    } else if (
      componentShowingInUH === DISAMBIGUATION_QUESTIONS ||
      componentShowingInUH === FAIL_SCREEN ||
      !componentShowingInUH
    ) {
      this.goToPrompt(currentGuid);
    } else {
      if (showFullPage) {
        let analyticsLabel;
        if (
          Object.values(actionsMap).includes(componentShowingInUH) &&
          analyticsLabelMap[componentShowingInUH.toLowerCase()]
        ) {
          analyticsLabel =
            analyticsLabelMap[componentShowingInUH.toLowerCase()];
        }

        let labelforAnalytics = analyticsLabel
          ? `${componentData.engLabelforAnalytics} : ${analyticsLabel}`
          : componentData.engLabelforAnalytics;

        setAdobeAnalyticsValue(
          'page_view',
          labelforAnalytics,
          'uhm_complete',
          currentTopLevelBranch
            ? currentTopLevelBranch
            : componentData.engLabelforAnalytics,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
      }
    }

    // Checking to see if there is an active chat
    if (launchDarklyFlags.tempInlineChatExperience) {
      log.debug(
        'DEBUGGING - CHAT SESSION - CHECKING IF THERE IS A CHAT SESSION'
      );

      if (
        hasCurrentChatSession &&
        ['', 'user-management', 'acc-downloads'].includes(contextualLinkOrigin)
      ) {
        log.debug('CHAT SESSION - DETECTED, LOADING CHAT');
        updateUHComponentShowingNow(CONTACT_OPTIONS);
        updateIsChatActive(true);
        // updateHeaderReloadAndBack(true);
      } else {
        log.debug(
          'DEBUGGING - CHAT SESSION - CHAT HAS NOT STARTED OR IT HAS EXPIRED'
        );
      }
    } else {
      // reset subheader if no follow me chat
      updateUhmSubHeaderType('AVA')
    }

    this.clearSalesChatComponentState();

    // Post message to Iframe that whether UHM is minimized or open
    this.postUhmWindowStateParent(showMainWindow, siteData.pageDomain);

    // Open UA after login redirect. Ignore if full page view AKN
    if (openAfterRedirect) {
      if (!showFullPage) {
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'uhm_icon_click',
            ev: 'automatic',
            cm_cs_request_id: requestId
          })
        );
        this.handleToggle();
      }
      updateOpenAferRedirect(false);
    }
    /**
     *  Experiment, Open UA proactively if `openAfterTime` is set on expDeeplinkOnOpen feature flag.
     * expDeeplinkOnOpen = {openAfterTime: 30, startHelpBranch: "buying-online"}
     * */

    if (!isEmpty(launchDarklyFlags.expDeeplinkOnOpen)) {
      const {openAfterTime = 0} = launchDarklyFlags.expDeeplinkOnOpen;
      if (isNumber(openAfterTime) && openAfterTime > 0) {
        setTimeout(() => {
          const {showMainWindow, hasUserInteracted} = this.props;
          if (showMainWindow === false && !hasUserInteracted) {
            adpAnalyticsLog(
              buildAdpAnalyticsPayload({
                e: 'uhm_icon_click',
                ev: 'automatic',
              })
            );
            this.handleToggle();
          }
        }, openAfterTime * 1000);
      }
    }

    // Hide any temp loading spinner on the index.html
    const loaderOnIndex = document.querySelector('.temp-loading-spinner');
    loaderOnIndex && loaderOnIndex.classList.add('hidden');
  }

  clearSalesChatComponentState = () => {
    const {
      showAgentAvailabilityFallbackComponent,
      showAnythingElseComponent,
      showPhoneHourBubbleComponent,
      updateShowAgentAvailabilityFallbackComponent,
      updateShowAnythingElseComponent,
      updateShowPhoneHourBubbleComponent,
      showMainWindow,
      toggleMainWindowAndFab,
    } = this.props;

    if (
      showAgentAvailabilityFallbackComponent ||
      showAnythingElseComponent ||
      showPhoneHourBubbleComponent ||
      showMainWindow
    ) {
      updateShowAgentAvailabilityFallbackComponent(false);
      updateShowAnythingElseComponent(false);
      updateShowPhoneHourBubbleComponent(false);
      toggleMainWindowAndFab(false);
    }
  };

  /**
   * control delay to open UA from IPH insights `Try it now` cta
   * https://jira.autodesk.com/browse/HAP-1608
   */
  autoOpenUaWithDelay = () => {
    const {tempIphInsightsTryNowCtaDelay} = this.props.flags;
    const { mode } = this.props.siteData;
    if (tempIphInsightsTryNowCtaDelay != 0 && mode === 'open') { // eslint-disable-line eqeqeq
      setTimeout(() => {
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'uhm_icon_click',
            ev: 'automatic'
          })
        );
        this.handleToggle();
      }, tempIphInsightsTryNowCtaDelay);
    }
  }

  async componentDidUpdate(prevProps) {
    const {siteData, resetToHome, viewingArticle, flags} = this.props;
    const {key, parents} = siteData.linkTo;
    const {showContextualPopUp} = siteData;

    // if user is in IPH Insights and "Try it now" cta, auto-open UA after fab renders
    if ((prevProps.flags.permanentShouldShowUa !== flags.permanentShouldShowUa) && (flags.permanentShouldShowUa)) {
      this.autoOpenUaWithDelay();
    }

    if (prevProps.siteData.linkTo !== siteData.linkTo) {
      if (this.state.showMainWindow) {
        await this.handleDeepLinks(key, parents);
      } else {
        await this.handleDeepLinks(key, parents);
        await this.handleOpenUHMThroughLink();
      }

      if (prevProps.showReloadAndBack !== this.props.showReloadAndBack) {
        await this.props.updateHeaderReloadAndBack(true);
      }
    } else if (prevProps.resetToHome !== resetToHome && resetToHome === true) {
      await this.resetStates();
      await this.handleReload();
    }

    // if flag goes from false to true
    // close welcome popup if open and open contextual
    if (!prevProps.siteData.showContextualPopUp && showContextualPopUp) {
      this.setState({showContextualPopUp: true, showWelcomePopUp: false});
      this.handlePopUpOpen('showContextualPopUp');
    }

    // check if contextual popup should be shown
    if (prevProps.viewingArticle !== viewingArticle) {
      const numArticlesSeen = isSessionStorageAvailable ? 
        parseInt(window.sessionStorage.getItem('numArticlesSeen')) + 1 : 0;
      isSessionStorageAvailable && window.sessionStorage.setItem('numArticlesSeen', numArticlesSeen);
      const flag = flags.expContextualPopup;

      // if number of articles seen in session is greater than FF value, show popup
      if (
        flag?.showPopup &&
        flag.popupType === 'pageCountBased' &&
        numArticlesSeen > flag.value
      ) {
        this.setState({showContextualPopUp: true, showWelcomePopUp: false});
        this.handlePopUpOpen('showContextualPopUp');
      }
      // if number time spent on a help article has surpassed FF value, show popup
      else if (
        flag?.showPopup &&
        flag.popupType === 'timeBased' &&
        flag.value
      ) {
        setTimeout(() => {
          this.setState({showContextualPopUp: true, showWelcomePopUp: false});
          this.handlePopUpOpen('showContextualPopUp');
          log.debug('[popup][UniversalHelp.js][timebased]', 'should show flag');
        }, flag.value * 1000);
      }
    }
  }

  //Updates state when deep link key is passed from hosting site
  handleDeepLinks = (linkToKey, parentGuids) => {
    const {
      workflowData: {prompts},
      siteData,
      updateDefaultSupportSkill,
      updateSfdcTopic,
      updateSfdcType,
      updateUHComponentShowingNow,
    } = this.props;
    if (
      !isEmpty(siteData.linkToModality) &&
      (siteData.linkToModality === 'case' ||
        siteData.linkToModality === 'scheduler')
    ) {
      this.resetStates();
      if (!isEmpty(prompts[siteData.linkTo.key])) {
        const {
          defaultSupportSkill = '',
          sfdcType = '',
          sfdcTopic = '',
        } = prompts[siteData.linkTo.key];
        updateDefaultSupportSkill(defaultSupportSkill);
        updateSfdcTopic(sfdcTopic);
        updateSfdcType(sfdcType);
        if (siteData.linkToModality === 'case') {
          updateUHComponentShowingNow(CONTACT_OPTION_CASE);
        } else if (siteData.linkToModality === 'scheduler') {
          updateUHComponentShowingNow(CONTACT_OPTION_SCHEDULER);
        }
        return new Promise((resolve) => resolve());
      }
    } else {
      return new Promise((resolve) => {
        try {
          //Check if the parentGuids is multi-dimentional.
          let validParentGuids = [];
          if (isArray(parentGuids[0])) {
            const allPrompts = Object.keys(prompts);
            for (const parentArr of parentGuids) {
              // Loop through each nested parents until you found the valid one.
              if (parentArr.every((i) => allPrompts.includes(i))) {
                validParentGuids =
                  parentArr[0] !== 'start'
                    ? ['start', ...parentArr]
                    : parentArr;
                break;
              }
            }
          } else {
            validParentGuids =
              parentGuids[0] !== 'start'
                ? ['start', ...parentGuids]
                : parentGuids;
          }

          validParentGuids.forEach((guid) => {
            if (guid === 'start') {
              this.goToPrompt(guid);
            } else {
              this.handleNext(prompts[guid]);
            }
          });

          //Prevents raise to update state
          setTimeout(() => {
            this.handleNext(prompts[linkToKey]);
            resolve();
          }, 100);
        } catch (e) {
          resolve();
        }
      });
    }
  };

  // post message parent know on toggle
  postUhmWindowStateParent = (
    showMainWindow,
    allowDomain,
    type = 'UHM_TOGGLE',
    containerHeight
  ) => {
    const {requestId, siteData} = this.props;
    const {flowId} = siteData;
    if (window.top !== window) {
      log.debug(
        'SHOW_TRIGGER',
        type,
        showMainWindow,
        containerHeight,
        allowDomain
      );
      setTimeout(() => {
        window.parent.postMessage(
          {
            type: type,
            isUhmOpen: showMainWindow,
            containerHeight,
            flowId,
            requestId,
          },
          allowDomain
        );
      });
    }
  };

  // manage sign into another account
  // if FF tempOAuth2 is on, then use forge method
  handleSignIntoAnotherClick = async () => {
    await forgeSignIntoAnotherAccount(this.props.tier);
  };

  resetStates = () => {
    const {
      updateContentSuggUserInput,
      updateSelectedProduct,
      updateSelectedVersion,
      updateExceptionMsg,
      updateSkillsResponse,
      updateSuggestedArticles,
      updateSuggestedArticleType,
      toggleUserInput,
      updateResolvedSupportSkill,
      closeAvaModal,
      updateContactAppLoading,
      workflowViaProp,
      workflowData,
      currentGuid,
      updateHideSecondaryNav,
      updateShowAdditionalQuestionsPage,
      updatelinkToADNSupportPage,
      updateUhmSubHeaderType,
      updateSaveChatTrigger,
      updateSettingsSiteData,
      siteData,
      updateEndChatTrigger,
      updateShowOverlayComponent,
      updateContextualLinkOrigin,
      updateUserInputFromAva,
      // updateShowAgentAvailabilityComponent,
      updateDeepLinkCAEduFlow,
      updateRequestId
    } = this.props;
    updateContentSuggUserInput(''); //Reset content suggestion user input.
    updateSelectedProduct(null); // Reset user selected product in content suggesstion
    updateSelectedVersion(null); // Reset user selected version in content suggesstion
    updateExceptionMsg('');
    updateSkillsResponse({}); //Reset cached Skill Api response
    updateSuggestedArticles([]);
    updateSuggestedArticleType('');
    updateResolvedSupportSkill('');
    toggleUserInput(true);
    closeAvaModal();
    updateContactAppLoading(true);
    updateHideSecondaryNav(false, '');
    updateShowAdditionalQuestionsPage(true);
    updatelinkToADNSupportPage(false);
    updateUhmSubHeaderType('AVA');
    updateSaveChatTrigger(0);
    updateEndChatTrigger(false);
    updateShowOverlayComponent(false);
    updateContextualLinkOrigin('');
    updateUserInputFromAva('');
    updateDeepLinkCAEduFlow(false);
    updateRequestId(null);
    // updateShowAgentAvailabilityComponent(false);

    this.clearSalesChatComponentState();

    //Reset the utmSourceOverride & flow Id
    const newFlowId = uuidv1();
    updateSettingsSiteData({
      ...siteData,
      utmSourceOverride: '',
      flowId: newFlowId,
      subOrigin: 'UHM',
    });

    // set source data depending on how we got the data
    let srcData =
      typeof workflowViaProp !== 'undefined' &&
      typeof workflowViaProp.prompts !== 'undefined'
        ? workflowViaProp
        : workflowData;

    // data for current guid
    let currentItem = srcData.prompts[currentGuid];
    this.handleSkillTypeTopic(currentItem);
  };
  // on reload, set prompt to starting point
  handleReload = ({
    userClick = false,
    fromLocation = null,
    hasModal = true,
  } = {}) => {
    const {showMainWindow} = this.state;
    const {
      startGuid,
      updateUHComponentShowingNow,
      componentShowingInUH,
      currentGuid,
      disableNavbar,
      hideSecondaryNav,
      updateShowModal,
      contactModalityShowing,
      updateOpenUHMThroughLink,
      openUHMThroughLink,
      contextualLinkOrigin,
      updateContextualLinkOrigin,
      updateResetToHome,
      hasInstructionalText,
      updateHasInstructionalText,
      endChatTrigger,
      siteData,
    } = this.props;

    if (disableNavbar) {
      return false;
    }

    // This condition is to reset hasInstructionalText to false when user clicks back
    if (hasInstructionalText) {
      updateHasInstructionalText(false);
    }

    // if home icon clicked from home, then do nothing
    if (
      currentGuid === startGuid &&
      componentShowingInUH === DISAMBIGUATION_QUESTIONS
    )
      return false;

    if (userClick && fromLocation === 'uhm_home_click') {
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'uhm_home_click',
          ev: 'Yes',
        })
      );
    }

    if (
      ((hideSecondaryNav && contactModalityShowing === 'inline_chat') ||
        (openUHMThroughLink &&
          ['user-management', 'acc-downloads', 'ava-sales-cta'].includes(
            contextualLinkOrigin
          ))) &&
      !endChatTrigger &&
      hasModal
    ) {
      updateShowModal(true, 'HOME');
      return false;
    }

    // reset the flag for contextual links to false and the contextualLinkOrigin to empty string
    if (openUHMThroughLink && contextualLinkOrigin !== '') {
      updateOpenUHMThroughLink(false);
      updateContextualLinkOrigin('');
    }

    // reset store states
    if (componentShowingInUH !== DISAMBIGUATION_QUESTIONS) {
      updateUHComponentShowingNow(DISAMBIGUATION_QUESTIONS);
    }

    if (userClick && (showMainWindow || siteData.showFullPage)) {
      const newFlowId = uuidv1();
      updateSettingsSiteData({
        ...siteData,
        utmSourceOverride: '',
        flowId: newFlowId,
      });
    }
    // resend to the start
    this.resetStates();
    this.goToPrompt(startGuid);
    updateResetToHome(false);
  };

  // on back, set the ui to the previous screen
  handleBack = () => {
    const {
      showForm,
      toggleUserInput,
      seenGuids,
      updateContentSuggUserInput,
      updateSelectedProduct,
      updateSelectedVersion,
      startGuid,
      updateSkillsResponse,
      updateSuggestedArticles,
      updateSuggestedArticleType,
      updateResolvedSupportSkill,
      updateExceptionMsg,
      exceptionMsg,
      updateUHComponentShowingNow,
      componentShowingInUH,
      lastComponentShown,
      lastComponentData,
      componentData,
      // currentPrompt,
      showAvaModal,
      siteData,
      disableNavbar,
      currentTopLevelBranch,
      updateContactAppLoading,
      contextualLinkOrigin,
      updatelinkToADNSupportPage,
      contactModalityShowing,
      requestId,
      contentSuggestionFlowRef,
      workflowViaProp,
      workflowData,
      currentGuid,
      updateShowResellerContactModality,
      hasInstructionalText,
      updateHasInstructionalText,
    } = this.props;
    const {showFullPage = false} = siteData;
    const {integrationType} = siteData;
    const isNewContentSuggestion = !showFullPage;

    let srcData =
      typeof workflowViaProp !== 'undefined' &&
      typeof workflowViaProp.prompts !== 'undefined'
        ? workflowViaProp
        : workflowData;

    // data for current guid
    let data =
      srcData && srcData.prompts ? srcData.prompts[currentGuid] : undefined;

    //needs to be called before disableNavbar check
    if (componentShowingInUH !== DISAMBIGUATION_QUESTIONS) {
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'back_btn_clicked',
          ev:
            stringJoinWordsWithDashes(componentData.engLabelforAnalytics) ||
            '1',
          cm_cs_request_id: requestId,
        })
      );
    }

    if (disableNavbar) {
      return false;
    }

    // This condition is to reset hasInstructionalText to false when user clicks back
    if (hasInstructionalText) {
      updateHasInstructionalText(false);
    }

    // reset the flag for sending ADN users to support in AP
    updatelinkToADNSupportPage(false);

    // last seen prompt guid or start
    const prevGuid = seenGuids.length > 1 ? seenGuids.slice(-2)[0] : startGuid;
    // update store states
    if (componentShowingInUH === CONTENT_SUGGESTION) {
      // check on contactModalityShowing could be removed once all in-modality back-btns are removed
      if (contactModalityShowing === '' && showFullPage && !showForm) {
        //AKNCU flow: triggers pageView when bck to CS input box from modalities home screen
        setAdobeAnalyticsValue(
          'page_view',
          `${componentData.engLabelforAnalytics} :Top Solutions`,
          'uhm_complete',
          currentTopLevelBranch,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
      }

      /* OLD UHM-APP flow + AKNCU: from CS links to CS input box*/
      if (!isNewContentSuggestion && !showForm) {
        // Generates new newRequestId for new CS inputs
        let newRequestId = uuidv1();
        toggleUserInput(true, newRequestId);
        updateContactAppLoading(true);
        // set content suggestion view ADP
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'cs_page_view',
            ev: stringJoinWordsWithDashes(componentData.engLabelforAnalytics),
            cm_cs_request_id: newRequestId,
          })
        );
      } else {
        // All flows: from CS input box to disambiguations scrn
        this.showPrompts();
        //CLEANUP: toggleUserInput added to fix bug when new CS input flow on new request did not trigger cs_page_view
        // consider passing a newReqID here instead of gen a new one in uiReducer under UPDATE_UH_COMPONENT_SHOWING_NOW action or vice
        toggleUserInput(true);
        updateContentSuggUserInput(''); //Reset content suggestion user input.
        updateSelectedProduct(null); // Reset user selected product in content suggesstion
        updateSelectedVersion(null); // Reset user selected version in content suggesstion
        updateExceptionMsg('');
        updateSkillsResponse({}); //Reset cached Skill Api response
        updateResolvedSupportSkill('');
        updateSuggestedArticles([]);
        updateSuggestedArticleType('');
        // case: L1 with no children 
        if (prevGuid === 'start' && 'description' in data && 'addBackButton' in data && !!data['addBackButton']) {
            this.goToPrompt(prevGuid);
        }
      }
    } else if (
      componentShowingInUH === CONTACT_OPTIONS &&
      lastComponentShown === AVA &&
      (contextualLinkOrigin === 'user-management' ||
        contextualLinkOrigin === 'acc-downloads' ||
        contextualLinkOrigin === 'ava-sales-cta')
    ) {
      updateUHComponentShowingNow(lastComponentShown, lastComponentData);
    } else if (componentShowingInUH === AVA) {
      if (!showFullPage) {
        showAvaModal('BACK');
      } else {
        //AKNCU: triggers pageView when bck to modalities screen
        setAdobeAnalyticsValue(
          'page_view',
          `${componentData.engLabelforAnalytics} :AVA`,
          '',
          currentTopLevelBranch,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
        this.resetStates();
        if (lastComponentShown === CAAS_CONTENT) {
          //If AVA is invoked from PBC send the user back to that.
          updateUHComponentShowingNow(lastComponentShown, lastComponentData);
        } else {
          this.showPrompts();
        }
      }
    } else if (
      componentShowingInUH === CONTACT_OPTIONS ||
      componentShowingInUH === CONTACT_OPTION_CASE ||
      componentShowingInUH === CAAS_CONTENT ||
      componentShowingInUH === LINKS ||
      componentShowingInUH === FAIL_SCREEN
    ) {
      if (
        // if the last component is AVA, then send them back to decision tree.
        (componentShowingInUH === CONTACT_OPTIONS &&
          lastComponentShown !== AVA &&
          lastComponentShown !== FAIL_SCREEN) ||
        // The user is currently on PBC via a link send them back to links
        (componentShowingInUH === CAAS_CONTENT &&
          (lastComponentShown === LINKS ||
            lastComponentShown === CONTENT_SUGGESTION)) ||
        componentShowingInUH === FAIL_SCREEN
      ) {
        if (
          lastComponentShown === DISAMBIGUATION_QUESTIONS ||
          lastComponentShown === CONTENT_SUGGESTION
        ) {
          let analyticsLabel;
          if (
            Object.values(actionsMap).includes(lastComponentShown) &&
            analyticsLabelMap[lastComponentShown.toLowerCase()]
          ) {
            analyticsLabel =
              analyticsLabelMap[lastComponentShown.toLowerCase()];
          }

          let labelforAnalytics = analyticsLabel
            ? `${lastComponentData.engLabelforAnalytics} : ${analyticsLabel}`
            : lastComponentData.engLabelforAnalytics;
          // set analytics event
          setAdobeAnalyticsValue(
            'page_view',
            labelforAnalytics,
            '',
            currentTopLevelBranch
              ? currentTopLevelBranch
              : lastComponentData.engLabelforAnalytics,
            '',
            'waf - uhm',
            'standard',
            siteData.language
          );
        } else if (
          lastComponentShown === LINKS ||
          lastComponentShown === CAAS_CONTENT
        ) {
          let analyticsLabel;
          if (
            Object.values(actionsMap).includes(lastComponentShown) &&
            analyticsLabelMap[lastComponentShown.toLowerCase()]
          ) {
            analyticsLabel =
              analyticsLabelMap[lastComponentShown.toLowerCase()];
          }

          let labelforAnalytics = analyticsLabel
            ? `${lastComponentData.engLabelforAnalytics} : ${analyticsLabel}`
            : lastComponentData.engLabelforAnalytics;
          // set analytics event
          setAdobeAnalyticsValue(
            'page_view',
            labelforAnalytics,
            'uhm_complete',
            currentTopLevelBranch
              ? currentTopLevelBranch
              : lastComponentData.engLabelforAnalytics,
            '',
            'waf - uhm',
            'standard',
            siteData.language
          );
        }

        updateUHComponentShowingNow(lastComponentShown, lastComponentData);
      } else if (
        componentShowingInUH === CAAS_CONTENT &&
        lastComponentShown === CONTACT_OPTIONS
      ) {
        if (integrationType === 'In-Product') {
          //Back to CS input box (in-product home)
          this.goToPrompt(startGuid);
        } else {
          if (!isEmpty(contentSuggestionFlowRef)) {
            updateUHComponentShowingNow(
              CONTENT_SUGGESTION,
              contentSuggestionFlowRef
            );
          } else {
            updateContactAppLoading(true);
            this.showPrompts();
          }
        }
      } else {
        updateContactAppLoading(true);
        this.showPrompts();
      }

      //This code is to update the showResellerContact flag
      if (data && data.showResellerContactModality) {
        updateShowResellerContactModality(true);
      } else {
        updateShowResellerContactModality(false);
        // this.handleSkillTypeTopic(data);
      }

      //CLEANUP: in new CS input flow, a dup event is triggered when exception
      // here and in cs lifecycle method
      //!isNewContentSuggestion added to prevent it
      if (exceptionMsg !== '' && !isNewContentSuggestion) {
        let newRequestId = uuidv1();
        toggleUserInput(true, newRequestId);
        // set content suggestion view ADP
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'cs_page_view',
            ev: stringJoinWordsWithDashes(componentData.engLabelforAnalytics),
            cm_cs_request_id: newRequestId,
          })
        );
        updateExceptionMsg('');
        updateSkillsResponse({}); //Reset cached Skill Api response
        updateResolvedSupportSkill('');
      }
    } else {
      updateContentSuggUserInput(''); //Reset content suggestion user input.
      updateSelectedProduct(null); // Reset user selected product in content suggesstion
      updateSelectedVersion(null); // Reset user selected version in content suggesstion
      updateExceptionMsg('');
      updateSkillsResponse({}); //Reset cached Skill Api response
      updateResolvedSupportSkill('');
      updateSuggestedArticles([]);
      updateSuggestedArticleType('');
      this.goToPrompt(prevGuid);
    }
  };

  // choose which popup to open with popupStateName, defaults to welcome popup
  handlePopUpOpen = (popupStateName = 'showWelcomePopUp') => {
    if (!this.state.showMainWindow) {
      this.setState({
        showWelcomePopUp: popupStateName === 'showWelcomePopUp',
        showContextualPopUp: popupStateName === 'showContextualPopUp',
      });
      window.parent.postMessage(
        {type: 'UHM_TOGGLE_TOOLTIP', open: true},
        this.props.siteData.pageDomain || 'localhost.autodesk.com:3000'
      );
    }
  };

  // choose which popup to close with popupStateName, defaults to both
  // dont resize the iframe if only closing one popup
  handlePopUpClose = (popupStateName) => {
    if (popupStateName) {
      this.setState({
        [popupStateName]: false,
      });
    } else {
      this.setState({
        showWelcomePopUp: false,
        showContextualPopUp: false,
      });
    }
    window.parent.postMessage(
      {type: 'UHM_TOGGLE_TOOLTIP', open: false},
      this.props.siteData.pageDomain || 'localhost.autodesk.com:3000'
    );
  };

  // on fab click, show/hide the Main window
  handleToggle = async ({userClick = false} = {}) => {
    const {showMainWindow} = this.state;
    const {
      siteData,
      currentGuid,
      currentTopLevelBranch,
      currentPrompt,
      disableNavbar,
      componentShowingInUH,
      userEntitlements,
      componentData,
      ldClient,
      openUHMThroughLink,
      toggleMainWindowAndFab,
      updateUserInteracted,
      updateContainerEventMessage,
      flags: launchDarklyFlags,
      updateSettingsSiteData,
      updateHeaderReloadAndBack,
      hasUserInteracted,
      requestId,
    } = this.props;

    const entitlement = getUserEntitlementLevel(userEntitlements);
      const isPowerUser = getIsPowerUser(entitlement);
    
      const aknUserRole = `${entitlement}${isPowerUser ? ' - Power User' : ''}`;

    // close welcome popup if open
    if (this.state.showWelcomePopUp || this.state.showContextualPopUp)
      this.handlePopUpClose();

    // don't show welcome popup after any user interaction
    this.setState({showWelcomePopUp: false, showContextualPopUp: false});
    if (isLocalStorageAvailable && !window?.localStorage?.getItem('welcomePopUpSeen')) {
      window?.localStorage?.setItem('welcomePopUpSeen', Date.now().toString());
    }
    if (isLocalStorageAvailable &&  !window?.localStorage?.getItem('UAIconClicked')) {
      window?.localStorage?.setItem('UAIconClicked', true);
    }

    if (showMainWindow) {
      if (userClick) {
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'uhm_minimize_click',
            ev: true,
            cm_cs_request_id: requestId
          })
        );
      }
      if (disableNavbar) {
        return false;
      }
    }

    // if false, then window is about to get shown
    if (showMainWindow === false && openUHMThroughLink === false) {
      // log click of question mark to adobe
      window.__analyticsChangeContext = window.__analyticsChangeContext || [];
      window.__analyticsChangeContext.push({
        event: {
          eventType: 'link_click',
        },
        link: {
          linkSection: 'uhm',
          linkTitle: 'question-mark',
        },
        uhm: {
          inititate: 'question-mark',
        },
        user: {
          aknUserRole,
        },
      });
      // Salesbot A/B test based on FeatureFlag on click of ? for the first time.
      let abTestDeeplink,
        abTestSettings = {};

      if (launchDarklyFlags.expSalesBotAbTest) {
        abTestDeeplink = 'AVA-sales-chat';

        abTestSettings = {
          utmSourceOverride: 'dotcom-sales_chatbot',
          subOrigin: 'UHM Sales Bot',
        };
      } else if (launchDarklyFlags.expEduAbTest) {
        abTestDeeplink = 'AVA-edu-flow';
      } else if (
        !isEmpty(launchDarklyFlags.expDeeplinkOnOpen) &&
        !isEmpty(launchDarklyFlags.expDeeplinkOnOpen.startHelpBranch)
      ) {
        abTestDeeplink = launchDarklyFlags.expDeeplinkOnOpen.startHelpBranch;
      }

      if (
        abTestDeeplink &&
        !hasUserInteracted &&
        componentShowingInUH !== CONTACT_OPTIONS
      ) {
        try {
          const linkTo = await fetchLinkToMapping(abTestDeeplink);

          updateSettingsSiteData({
            ...siteData,
            linkTo: linkTo,
            ...abTestSettings,
          });
          updateHeaderReloadAndBack(true);
        } catch (error) {
          log.error(`Error loading ${abTestDeeplink} A/B Test`, error);
        }
      }
      // set analytics event, on the toggle open
      if (currentGuid === START_GUID) {
        if (ldClient) {
          ldClient.track('clickOnUHM');
        }
        // dont log unless the fab has been clicked and window is open
        setAdobeAnalyticsValue(
          'page_view',
          'initial selection',
          'uhm_start',
          '',
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
        // create condition here to not fire ADP event if modern experience true
        if (!launchDarklyFlags.expSalesBotAbTest) {
          adpAnalyticsLog(
            buildAdpAnalyticsPayload({
              e: 'initial_screen_page_view',
              ev: true,
              cm_cs_request_id: requestId
            })
          );
        }
      } else {
        let analyticsLabel;
        if (
          Object.values(actionsMap).includes(componentShowingInUH) &&
          analyticsLabelMap[componentShowingInUH.toLowerCase()]
        ) {
          analyticsLabel =
            analyticsLabelMap[componentShowingInUH.toLowerCase()];
        }
        let labelforAnalytics = analyticsLabel
          ? `${componentData.engLabelforAnalytics} : ${analyticsLabel}`
          : currentPrompt.engLabelforAnalytics;

        if (
          componentShowingInUH !== 'CONTENT_SUGGESTION' &&
          componentShowingInUH !== 'CONTACT_OPTIONS'
        ) {
          setAdobeAnalyticsValue(
            'page_view',
            labelforAnalytics,
            '',
            currentTopLevelBranch
              ? currentTopLevelBranch
              : currentPrompt.engLabelforAnalytics,
            '',
            'waf - uhm',
            'standard',
            siteData.language
          );
        }
      }
    }

    const timeout =
      showMainWindow && launchDarklyFlags.tempAnimateMainWindow ? 400 : 0;
    this.setState({windowIsClosing: showMainWindow});

    // when window is minimizing, allow 200ms to pass for fade-out animation
    setTimeout(() => {
      // send a message to the agent notifying the window has been minimized
      const message = showMainWindow ? 'UHMCollapsed' : 'UHMShow';
      if (componentShowingInUH === 'CONTACT_OPTIONS') updateContainerEventMessage(message);

      // Post message to Iframe that whether UHM is minimized or open
      this.postUhmWindowStateParent(!showMainWindow, siteData.pageDomain);
      toggleMainWindowAndFab(!showMainWindow);
      updateUserInteracted(true);
      this.setState({showMainWindow: !showMainWindow, windowIsClosing: false});
    }, timeout);
  };

  handleOpenUHMThroughLink = () => {
    const {openUHMThroughLink} = this.props;

    if (openUHMThroughLink && this.state.showMainWindow) {
      return;
    } else if (openUHMThroughLink && !this.state.showMainWindow) {
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'uhm_icon_click',
          ev: 'cta',
        })
      );
      this.handleToggle();
    }

    return;
  };

  handleAvaRestart = () => {
    const {showAvaModal} = this.props;
    //ADP Analytics
    adpAnalyticsLog(
      buildAdpAnalyticsPayload({
        e: 'ic_restart_chat',
      })
    );
    // updateShowAgentAvailabilityFallbackComponent(false);
    showAvaModal('RESTART');
  };

  handleConversationalRestart = ({ev = 'support_sub header'}) => {
    const {updateShowModal, requestId} = this.props;
    adpAnalyticsLog(
      buildAdpAnalyticsPayload({
        e: 'ic_restart_chat',
        ev,
        cm_cs_request_id: requestId
      })
    );
    updateShowModal(true, 'HOME', 'restart');
  };

  handleEndChat = () => {
    const {updateShowModal, isAnythingElseEndChat, uhmSubHeaderType, siteData, requestId} = this.props;
    const {integrationType} = siteData;
    const isInProduct = integrationType === 'In-Product';

    if (uhmSubHeaderType === 'chat') {
      updateShowModal(true, 'CHAT_ENDED_SCREEN');
      const ev = isInProduct ? 'support_human_agent_no' : undefined;
      //ADP Analytics
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'ic_end_chat_click',
          ev,
          cm_cs_request_id: requestId
        })
      );
    } else if (isAnythingElseEndChat) {
      this.handleConfirmModalAction('Yes');
      //ADP Analytics
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'ic_end_chat',
          ev: 'Yes',
        })
      );
    } else {
      const ev = isInProduct ? 'support_sub-header' : 'sub-header';
      //ADP Analytics
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'ic_end_chat_click',
          ev,
          cm_cs_request_id: requestId
        })
      );
      updateShowModal(true, 'HOME');
    }
  };

  // clean up json data
  // and set up current screen for user
  goToPrompt = (goToGuid) => {
    const {showMainWindow} = this.state;
    const {
      startGuid,
      showReloadAndBack,
      updateHeaderReloadAndBack,
      updateContentSuggUserInput,
      updateSelectedProduct,
      updateSelectedVersion,
      workflowData, // data via the workflow fetch
      workflowViaProp, // data via unit tests
      seenGuids,
      updateSeenGuids,
      updateCurrentGuid,
      updateCurrentPrompt,
      updateShowContactFooter,
      updateDefaultEscapeActionGuid,
      updateShowContactDetailsInAction,
      updateHideTopicNotListed,
      updateHideContactModalities,
      updateShowResellerContactModality,
      updateCurrentTopLevelBranch,
      currentGuid,
      currentTopLevelBranch,
      siteData,
      componentShowingInUH,
      // updateUHComponentShowingNow,
      quickToggleShowPhoneFooter,
      showContactFooter,
      defaultSupportSkill,
      sfdcType,
      sfdcTopic,
      updateUserContext,
      openUHMThroughLink,
    } = this.props;
    const {integrationType} = siteData;
    const isInProduct = integrationType === 'In-Product';
    // if no data then return as empty
    if (
      typeof workflowData === 'undefined' &&
      typeof workflowViaProp === 'undefined'
    ) {
      this.handleFail();
      return;
    }
    // if no prompts then return as empty
    if (
      typeof workflowData.prompts === 'undefined' &&
      workflowViaProp &&
      typeof workflowViaProp.prompts === 'undefined'
    ) {
      this.handleFail();
      return;
    }

    if (componentShowingInUH === FAIL_SCREEN) {
      this.showPrompts();
    }

    // set source data depending on how we got the data
    let srcData =
      typeof workflowViaProp !== 'undefined' &&
      typeof workflowViaProp.prompts !== 'undefined'
        ? workflowViaProp
        : workflowData;

    // data for current guid
    let data =
      srcData && srcData.prompts ? srcData.prompts[goToGuid] : undefined;

    let temp;
    // get children
    if (data && isNotEmptyArray(data.next)) {
      let children = data.next.map((item) => {
        const promptGuid = typeof item === 'string' ? item : item.guid;
        temp =
          typeof srcData.prompts[promptGuid] === 'undefined'
            ? {}
            : srcData.prompts[promptGuid];
        temp.guid = promptGuid;
        return temp;
      });
      data.next = children;
    }
    // fill in solutions/actions
    if (data && isNotEmptyArray(data.actions)) {
      let actions = this.getActions(data.actions);
      data.actions = actions;
    }
    this.handleSkillTypeTopic(data);

    // if currentGuid is the start then set top level branch to the label of the gotoguid
    if (currentGuid === startGuid && data)
      updateCurrentTopLevelBranch(data.engLabelforAnalytics);

    // update seen guids
    updateSeenGuids(seenGuids, goToGuid);

    // call action creator to toggle reload and back button
    if (goToGuid !== startGuid && !showReloadAndBack) {
      updateHeaderReloadAndBack(true);
    }

    // is start screen, hide toggles for reload and back button
    if (goToGuid === startGuid && showReloadAndBack) {
      updateHeaderReloadAndBack(false); // if disambiguations questions are being shown, and its the start guid then hide header reload and back
      !isInProduct && updateContentSuggUserInput(''); //Reset content suggestion user input.
      updateSelectedProduct(null); // Reset user selected product in content suggesstion
      updateSelectedVersion(null); // Reset user selected version in content suggesstion
      updateCurrentTopLevelBranch('');
    }

    // set currentGuid to store
    updateCurrentGuid(goToGuid);

    // set the current prompt being shown to store
    updateCurrentPrompt(data);

    // set showContactFooter flag
    if (
      data &&
      data.showContactFooter !== undefined &&
      data.showContactFooter !== null &&
      data.showContactFooter !== showContactFooter
    ) {
      updateShowContactFooter(data.showContactFooter);
    }

    // set defaultEscapeActionGuid
    if (
      data &&
      (data.defaultEscapeActionGuid || data.defaultEscapeActionGuid === '')
    ) {
      updateDefaultEscapeActionGuid(data.defaultEscapeActionGuid);
    }

    // Set userContext (currently only Edu)
    if (data && (data.userContext || data.userContext === '')) {
      updateUserContext(data.userContext);
    }

    // set showContactDetailsInAction
    if (data && data.showContactDetailsInAction) {
      updateShowContactDetailsInAction(data.showContactDetailsInAction);
    }
    // set updateHideTopicNotListed
    if (data && data.hideTopicNotListed) {
      updateHideTopicNotListed(data.hideTopicNotListed);
    }

    if (data && data.hideContactModalities) {
      updateHideContactModalities(true);
    } else {
      updateHideContactModalities(false);
    }

    if (data && data.showResellerContactModality) {
      updateShowResellerContactModality(true);
    } else {
      updateShowResellerContactModality(false);
    }

    // re-render sales footer if needed
    const willShowPhoneFooter =
      showContactFooter &&
      seenGuids.length > 1 &&
      !(defaultSupportSkill && sfdcTopic && sfdcType) &&
      (!prompt.actions || (prompt.actions && prompt.actions.length === 0));

    if (willShowPhoneFooter) {
      quickToggleShowPhoneFooter(false);
      setTimeout(() => {
        quickToggleShowPhoneFooter(true);
      }, 1);
    }

    if (siteData.showFullPage && goToGuid === START_GUID) {
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'initial_screen_page_view',
          ev: 'true',
        })
      );
    }

    // dont log unless the fab has been clicked and window is open
    if (showMainWindow && openUHMThroughLink === false) {
      // set analytics event
      if (goToGuid === START_GUID) {
        setAdobeAnalyticsValue(
          'page_view',
          'initial selection',
          'uhm_start',
          '',
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
      } else {
        setAdobeAnalyticsValue(
          'page_view',
          data.engLabelforAnalytics,
          '',
          currentTopLevelBranch
            ? currentTopLevelBranch
            : data.engLabelforAnalytics,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );
      }
    }
    // If start branch doesn't have any children then show actions directly.
    if (
      goToGuid === START_GUID &&
      !data.next &&
      isNotEmptyArray(data.actions)
    ) {
      this.handleNext(data);
    }
  };

  getActions = (actions = []) => {
    const {
      workflowData, // data via the workflow fetch
      workflowViaProp,
    } = this.props;
    let srcData =
      typeof workflowViaProp !== 'undefined' &&
      typeof workflowViaProp.prompts !== 'undefined'
        ? workflowViaProp
        : workflowData;
    const actionsWithData = actions.map((item) => {
      const actionGuid = typeof item === 'string' ? item : item.guid;
      let temp = srcData.actions[actionGuid];
      temp.guid = actionGuid;
      return temp;
    });
    return actionsWithData;
  };

  handleNext = (currentItem, userClick = false) => {
    const {
      updateUHComponentShowingNow, // data via the workflow fetch
      updateShowContactDetailsInAction,
      updateHideContactModalities,
      updateShowResellerContactModality,
      updatelinkToADNSupportPage,
      currentTopLevelBranch,
      siteData,
      currentGuid,
      contextualLinkOrigin,
    } = this.props;
    if (isEmpty(currentItem)) {
      return;
    }
    if (currentGuid === START_GUID) {
      if (
        isEmpty(contextualLinkOrigin) &&
        isEmpty(siteData.utmSourceOverride) &&
        siteData.integrationType !== 'In-Product' // Don't fire for In-Product.
      ) {
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'main_branch_selection',
            ev: currentItem.engLabelforAnalytics,
          })
        );
      }
    } else {
      if (userClick && !isEmpty(currentItem.next)) {
        adpAnalyticsLog(
          buildAdpAnalyticsPayload({
            e: 'sub_branch_page_view',
            ev: currentItem.engLabelforAnalytics,
          })
        );
      }
    }

    if (isEmpty(currentItem.next)) {
        // case: L1 with no children
        if ('description' in currentItem && 'addBackButton' in currentItem && !!currentItem['addBackButton']) {
            if (isEmpty(currentItem.guid)) {
                return;
              }
           this.goToPrompt(currentItem.guid);
        }

      //update hideContactModalities flag.
      if (currentItem && currentItem.hideContactModalities) {
        updateHideContactModalities(true);
      } else {
        updateHideContactModalities(false);
      }
      if (currentItem && currentItem.showResellerContactModality) {
        updateShowResellerContactModality(true);
      } else {
        updateShowResellerContactModality(false);
      }

      if (isEmpty(currentItem.actions)) {
        this.handleSkillTypeTopic(currentItem);
        // If no actions or children then route to contact options;
        updateUHComponentShowingNow(CONTACT_OPTIONS, {
          label: currentItem.label,
        });
        setAdobeAnalyticsValue(
          'page_view',
          currentItem.engLabelforAnalytics,
          'uhm_complete',
          currentTopLevelBranch,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );

        return;
      } else {
        this.handleSkillTypeTopic(currentItem);
        const actionsWithData = this.getActions(currentItem.actions);
        const {mode, data} = actionsWithData[0]; //TODO: show the first action for now. Refactor later if more than one needs to be shown.
        const actionToShow = actionsMap[mode];
        const analyticsLabel = analyticsLabelMap[mode];
        let tmpPageType =
          actionToShow === 'CONTENT_SUGGESTION' ? '' : 'uhm_complete';

        setAdobeAnalyticsValue(
          'page_view',
          `${currentItem.engLabelforAnalytics} : ${analyticsLabel}`,
          tmpPageType,
          currentTopLevelBranch,
          '',
          'waf - uhm',
          'standard',
          siteData.language
        );

        // link "All other customers" to external support for specific use case
        if (currentItem.linkToADNSupportPage) {
          updatelinkToADNSupportPage(currentItem.linkToADNSupportPage);
        }

        // set showContactDetailsInAction
        if (typeof currentItem.showContactDetailsInAction !== 'undefined') {
          updateShowContactDetailsInAction(
            currentItem.showContactDetailsInAction
          );
        }
        const componentData = {
          label: currentItem.label,
          engLabelforAnalytics: currentItem.engLabelforAnalytics,
          ...data,
        };
        userClick &&
          adpAnalyticsLog(
            buildAdpAnalyticsPayload({
              e: 'sub_branch_page_view',
              ev: currentItem.engLabelforAnalytics,
              cm_cs_topic_title: currentItem.engLabelforAnalytics,
            })
          );
        actionToShow &&
          updateUHComponentShowingNow(actionToShow, componentData);
      }
    } else {
      if (isEmpty(currentItem.guid)) {
        return;
      }
      this.goToPrompt(currentItem.guid);
    }
  };

  showPrompts = () => {
    const {
      workflowViaProp,
      workflowData,
      updateUHComponentShowingNow,
      currentGuid,
      currentTopLevelBranch,
      siteData,
    } = this.props;
    // set source data depending on how we got the data
    let srcData =
      typeof workflowViaProp !== 'undefined' &&
      typeof workflowViaProp.prompts !== 'undefined'
        ? workflowViaProp
        : workflowData;

    // data for current guid
    let currentItem = srcData.prompts[currentGuid];
    this.handleSkillTypeTopic(currentItem);
    updateUHComponentShowingNow(DISAMBIGUATION_QUESTIONS);
    // set analytics on back to DISAMBIGUATION_QUESTIONS
    setAdobeAnalyticsValue(
      'page_view',
      currentItem.engLabelforAnalytics,
      '',
      currentTopLevelBranch
        ? currentTopLevelBranch
        : currentItem.engLabelforAnalytics,
      '',
      'waf - uhm',
      'standard',
      siteData.language
    );
  };

  handleSkillTypeTopic = (currentItem) => {
    const {
      updateDefaultSupportSkill,
      updateSfdcType,
      updateSfdcTopic,
      updatePremiumSupportSkill,
      updatePremiumSfdcType,
      updatePremiumSfdcTopic,
    } = this.props;

    const defaultSkill =
      currentItem && currentItem.defaultSupportSkill
        ? currentItem.defaultSupportSkill
        : '';
    const sfdcType =
      currentItem && currentItem.sfdcType ? currentItem.sfdcType : '';
    const sfdcTopic =
      currentItem && currentItem.sfdcTopic ? currentItem.sfdcTopic : '';

    const premiumSkill =
      currentItem && currentItem.premiumSupportSkill
        ? currentItem.premiumSupportSkill
        : '';
    const premiumSfdcType =
      currentItem && currentItem.premiumSfdcType
        ? currentItem.premiumSfdcType
        : '';
    const premiumSfdcTopic =
      currentItem && currentItem.premiumSfdcTopic
        ? currentItem.premiumSfdcTopic
        : '';

    // set defaultSupportSkill in store
    updateDefaultSupportSkill(defaultSkill);
    // set sfdcType in store
    updateSfdcType(sfdcType);
    // set sfdcTopic in store
    updateSfdcTopic(sfdcTopic);

    //Premium support skill and type and topic.
    updatePremiumSupportSkill(premiumSkill);
    updatePremiumSfdcType(premiumSfdcType);
    updatePremiumSfdcTopic(premiumSfdcTopic);
  };

  handleFail = () => {
    const {updateUHComponentShowingNow} = this.props;
    updateUHComponentShowingNow(FAIL_SCREEN);
  };

  handleConfirmModalAction = (action = 'Yes') => {
    const {
      updateShowModal,
      updateHideSecondaryNav,
      goToAfterConfirm,
      updateIsChatActive,
      updateOpenUHMThroughLink,
      updateContextualLinkOrigin,
      isEndChatThroughButton,
      updateIsEndChatThroughButton,
      updateEndChatTrigger,
      updateSaveChatTrigger,
      updateShowOverlayComponent,
      contextualLinkOrigin,
      updateSubOrigin,
      siteData,
      flags: launchDarklyFlags,
      requestId
    } = this.props;
    const {integrationType} = siteData;
    const isInProduct = integrationType === 'In-Product';
    if (action === 'Yes') {
      const ev = isInProduct ? 'Support_Yes' : 'Yes';
      // this.resetStates();
      switch (goToAfterConfirm) {
        case 'HOME':
          updateHideSecondaryNav(false, '');
          updateShowModal(false, '');
          updateIsChatActive(false);
          updateOpenUHMThroughLink(false);
          updateContextualLinkOrigin('');
          updateSubOrigin('UHM');
          if (isEndChatThroughButton) this.handleToggle();
          setTimeout(() => {
            updateIsEndChatThroughButton(false);
            this.handleReload({userClick: true});
          }, 10);
          adpAnalyticsLog(
            buildAdpAnalyticsPayload({
              e: 'ic_end_chat',
              ev,
              cm_cs_request_id: requestId
            })
          );
          break;
        case 'CHAT_ENDED_SCREEN':
          updateShowModal(false);
          updateEndChatTrigger(true);
          updateShowOverlayComponent(true);
          updateSubOrigin('UHM');
          //ADP Analytics
          adpAnalyticsLog(
            buildAdpAnalyticsPayload({
              e: 'ic_end_chat',
              ev,
              cm_cs_request_id: requestId
            })
          );
          break;
        default:
          updateHideSecondaryNav(false, '');
          updateOpenUHMThroughLink(false);
          // updateContextualLinkOrigin('');
          updateShowModal(false, goToAfterConfirm);
          if (
            contextualLinkOrigin === 'ava-sales-cta' ||
            launchDarklyFlags.expSalesBotAbTest
          ) {
            adpAnalyticsLog(
              buildAdpAnalyticsPayload({
                e: 'uhm_icon_click',
                ev: 'cta',
              })
            );
              this.handleToggle();
          }
          setTimeout(() => {
            this.goToPrompt(
              contextualLinkOrigin === 'ava-sales-cta' ||
                launchDarklyFlags.expSalesBotAbTest
                ? 'start'
                : goToAfterConfirm
            );
            this.showPrompts();
            this.resetStates();
          }, 10);
          break;
      }
    } else if (action === 'SaveChat') {
      //ADP Analytics
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'ic_save_chat_transcript_click',
          ev: 'support_end_chat_screen',
        })
      );
      updateSaveChatTrigger();
    } else {
      //ADP Analytics
      adpAnalyticsLog(
        buildAdpAnalyticsPayload({
          e: 'ic_end_chat',
          ev: isInProduct ? 'Support_No' : 'No',
          cm_cs_request_id: requestId
        })
      );
      updateIsEndChatThroughButton(false);
      updateShowModal(false);
    }
  };
  resizeIframeSize = ({downsize = false} = {}) => {
    const {pageDomain} = this.props.siteData;
    const {showMainWindow} = this.state;
    setTimeout(() => {
      let uhmDiv = document.querySelector('div.widget__window--full-page');
      const containerHeight = uhmDiv ? uhmDiv.offsetHeight : 650;
      const eventType = downsize ? 'UHM_DOWNSIZE' : 'UHM_RESIZE';
      this.postUhmWindowStateParent(
        showMainWindow,
        pageDomain,
        eventType,
        containerHeight + 200 // Added extra height for case form buttons
      );

      //Window Re-size eventlisner.
      window.addEventListener('resize', () => {
        let uhmDiv = document.querySelector('div.widget__window--full-page');
        const containerHeight = uhmDiv ? uhmDiv.offsetHeight : 650;
        const eventType = 'UHM_RESIZE';
        this.postUhmWindowStateParent(
          showMainWindow,
          pageDomain,
          eventType,
          containerHeight + 200 // Added extra height for case form buttons
        );
      });
    }, 100);
    //TODO: Secondary resize event after a 1.5sec to resize iframe to avoid any hiddent content - Temp Fix
    [1500, 5000, 10000].map((delay) =>
      setTimeout(() => {
        let uhmDiv = document.querySelector('div.widget__window--full-page');
        const containerHeight = uhmDiv ? uhmDiv.offsetHeight : 650;
        const eventType = downsize ? 'UHM_DOWNSIZE' : 'UHM_RESIZE';
        this.postUhmWindowStateParent(
          showMainWindow,
          pageDomain,
          eventType,
          containerHeight + 200 // Added extra height for case form buttons
        );
      }, delay)
    );
  };

  handleScrollTopImmediate = () => {
    this.postUhmWindowStateParent(
      this.state.showMainWindow,
      this.props.siteData.pageDomain,
      'UHM_SCROLLTOP_IMMEDIATE'
    );
  };

  // choose which popup to evaluate for render with popupStateName, defaults to welcome
  shouldRenderPopUp = (popupStateName = 'showWelcomePopUp') => {
    const isFullPage = this.props.siteData.showFullPage;
    const isMobileDevice = this.props.siteData.isMobileDevice;
    const result = this.state[popupStateName] && !isFullPage && !isMobileDevice;

    const featureFlagNames = {showWelcomePopUp: 'expWelcomePopupConfig', showContextualPopUp: 'expContextualPopup'};
    const featureFlag = this.props.flags[featureFlagNames[popupStateName]];
    const isFeatureFlagDefined = typeof featureFlag !== 'undefined';

    // if UA has been clicked, never show a popup UNLESS alwaysShow is defined
    // if contextual Feature Flag is off, never show it
    if (
      (isFeatureFlagDefined ?
        (isLocalStorageAvailable && window?.localStorage?.getItem('UAIconClicked') && !(featureFlag.alwaysShow)) :
        (isLocalStorageAvailable && window?.localStorage?.getItem('UAIconClicked')))  ||
      (popupStateName === 'showContextualPopUp' &&
        !featureFlag?.showPopup)
    ) {
      return false;
    } else {
      return result;
    }
  };

  render() {
    const {
      currentGuid,
      showReloadAndBack,
      showAvaConfirmModal,
      componentShowingInUH,
      updateUHComponentShowingNow,
      lastComponentShown,
      fail,
      siteData,
      userDetails,
      componentData,
      showForm,
      flags: launchDarklyFlags,
      toggleShowFeedbackWidgetFlow,
      showFeedbackWidgetFlow,
      requestId,
      contentSuggLoading,
      avaLoading,
      avaConfirmAction,
      closeAvaModal,
      lastComponentData,
      hideSecondaryNav,
      showConfirmModal,
      openUHMThroughLink,
      contextualLinkOrigin,
      isFeedbackWidgetMounted,
      colorsToUpdate,
      updateIsEndChatThroughButton,
      uhmSubHeaderType,
      updateSaveChatTrigger,
      showOverlayComponent,
      confirmModalType,
      popUpMainWindow,
      hasUserInteracted,
    } = this.props;

    const showFullPageHeader = siteData.showFullPage;
    const {showMainWindow, windowIsClosing} = this.state;
    const {showFullPage = false, mode} = siteData;
    const {
      tempRosetta,
      expSalesBotAbTest,
      expEduAbTest,
      expDeeplinkOnOpen = {},
    } = launchDarklyFlags;
    const {modernHeaderText = false} = expDeeplinkOnOpen;
    const isInProduct = siteData.integrationType === 'In-Product';
    const shouldRenderWindow =
      hasUserInteracted ||
      showFullPage ||
      ['openWidget', 'open'].includes(mode ) ||
      popUpMainWindow ||
      hasChatInPrevPage().hasCurrentChatSession;

    showFullPage &&
      componentShowingInUH === DISAMBIGUATION_QUESTIONS &&
      lastComponentShown === AVA &&
      this.postUhmWindowStateParent(
        showMainWindow,
        siteData.pageDomain,
        'UHM_SCROLLTOP'
      );
    showFullPage && this.resizeIframeSize();
    let openWidgetClass = '';
    if (siteData.mode && siteData.mode === 'openWidget') {
      openWidgetClass = 'no-margin';
    }

    // fab icon and main window styles
    let wrapperClasses = siteData.showFullPage
      ? `flyout__wrapper--fullPage ${openWidgetClass}`
      : `flyout__wrapper ${
          isInProduct
            ? `flyout__wrapper--in-product ${siteData.product ?? ''}`
            : ''
        } ${!windowIsClosing ? 'flyout--hidden' : ''} ${openWidgetClass} ${
          launchDarklyFlags.tempAnimateMainWindow
            ? windowIsClosing
              ? `uhm-fade-out`
              : `uhm-fade-in`
            : null
        }`;
    let fabClass = siteData.showFullPage
      ? `flyout__wrapper ${openWidgetClass}`
      : 'uh-fab uh-fab--hidden';
    if (showMainWindow) {
      // wrapperClasses += ' flyout--show';
      // fabClass += ' uh-fab--hidden';
    } else {
      // wrapperClasses += ' flyout--hidden';
    }
    let secButtonProps = {};
    let addBackgroundColorForAvaFeedback = '';
    if (componentShowingInUH === AVA) {
      secButtonProps = {
        showSecRestart: true,
        onSecRestart: this.handleAvaRestart,
      };
      if (isFeedbackWidgetMounted) {
        addBackgroundColorForAvaFeedback = ' widget__window--dark';
      }
    }

    const shouldShowSecondaryNav = hideSecondaryNav ? false : showReloadAndBack;
    const showConversationalContainer =
      siteData.integrationType === 'In-Product' && !['NINVFUS', 'ACADMOBILE'].includes(siteData.product);

    if (
      componentShowingInUH === CONTENT_SUGGESTION &&
      showConversationalContainer
    ) {
      secButtonProps = {
        showSecRestart: true,
        onSecRestart: this.handleConversationalRestart,
      };
    }

    /**
     * Objects the feature flag text
     * 1. Add the variation name to the list - TRANSLATE_FEATURE_FLAG_TEXT
     * 2. Add the nessary text inside respective attribute in featureFlagText Object
     */

    const featureFlagText = {
      "accountsPortalStepOne": {
        text: <Trans>DID YOU KNOW? <br/>You can now create a support case by simply clicking the question mark."</Trans>,
        primaryButtonText:null,
        secondaryButtonText: null
      },
      "accountsPortalStepTwo":{
        text:<Trans>IMPORTANT UPDATE: <br/>Beginning April 1st, this will be the only location to submit all your enterprise support cases. All links previously used will be retired.</Trans>,
        primaryButtonText:<Trans>Got it</Trans>,
        secondaryButtonText: null
      },
      "accountsPortalStepThree":{
        text:<Trans>Enterprise customers can create a case right here to contact support!</Trans>,
        primaryButtonText:null,
        secondaryButtonText: null,
      }
    }

    // Making it read-only to prevent overides
      const TRANSLATE_FEATURE_FLAG_VARIATIONS = Object.freeze([
        "accountsPortalStepOne",
        "accountsPortalStepTwo",
        'accountsPortalStepThree'
      ]);


    // get popup text options
    // type can be extended in the future for use with feature flags for experimentation
    // JSON feature flags could also control the options like dismiss seconds etx...
    // defaults to welcome popups for both dotcom and ACD
    const getPopupTextOptions = (type) => {
      const defaultPopUpConfig = {
        delaySeconds: 2,
        dismissSeconds: 10,
        intervalDays: 1,
        beta: false,
      };

      const welcomeMessage = <Trans>Hi</Trans>;
      const welcomeMessagesWithFirstName =
      <>
        {welcomeMessage}
        {userDetails?.first ? ', ' + userDetails?.first + '!' : null}
      </>
      const welcomeMessagesWithLastNameJPN = `${userDetails?.last} さん、こんにちは ! `
      const helpArticlesMessage = (
        <Trans style={{size: '14px', lineHeight: '21px'}}>
          Thanks for checking out our help articles. Do you need any more help?
        </Trans>
      );

      // Feature flag variations that needs translation
      const variationName = launchDarklyFlags?.expContextualPopup?.variationName
        || launchDarklyFlags?.expWelcomePopupConfig?.variationName

      const translationFeatureFlagText = TRANSLATE_FEATURE_FLAG_VARIATIONS
        .includes(variationName) ?
          featureFlagText[variationName] : null

      switch (type) {
        // contextual popups
        case 'contextualPopUp':
          const includeUser = launchDarklyFlags?.expContextualPopup.includeUser ? true: false;
          const title = userDetails?.first && includeUser ? <>{welcomeMessage} {userDetails?.first + '!'}</> : <Trans>Hi there!</Trans>;
          // options to override defaultPopUpConfig are configured in launch darkly
          // https://app.launchdarkly.com/uhm_dhxdevops/development/features/expContextualPopup/variations
          return {
            ...defaultPopUpConfig,
            title: title,
            text: translationFeatureFlagText?.text ?? helpArticlesMessage,
            launchDarklyFlags,
            ...(translationFeatureFlagText && {primaryButtonText:translationFeatureFlagText?.primaryButtonText }),
            ...(translationFeatureFlagText && {secondaryButtonText:translationFeatureFlagText?.secondaryButtonText }),
            ...launchDarklyFlags?.expContextualPopup,
          };
        // welcome popups
        default:
          if (
            siteData?.integrationType === 'In-Product' &&
            siteData?.product !== 'NINVFUS'
          ) {
            return {
              // TODO: For some undetermined reason, variable interpolation in linqui macros is broken.
              //       AutoCAD is in English only for the moment so non-translated messages are sufficient.
              // title: userDetails?.first ? <Trans id="Hi, {name}!" values={{name: userDetails.first}}/> : <Trans>Hi!</Trans>,
              ...defaultPopUpConfig,
              title: userDetails?.first ?
                siteData.language === 'ja_JP' ?
                welcomeMessagesWithLastNameJPN :
                welcomeMessagesWithFirstName :
                <Trans>Hi there!</Trans>,
              text: (
                <Trans>
                  I’m an AI powered assistant here to help you find solutions or
                  contact a human agent.
                </Trans>
              ),
              launchDarklyFlags,
              ...launchDarklyFlags.expWelcomePopupConfig,
              beta: true,
            };
          }
          if (!!launchDarklyFlags?.expContextualPopup?.includeUser && userDetails?.first) {
            return {
              // TODO: Needs clean up for this entire function
              ...defaultPopUpConfig,
              title: (
                <>
                  {welcomeMessage}
                  {userDetails?.first ? ', ' + userDetails?.first + '!' : <Trans>Hi there!</Trans>}
                </>
              ),
              text: (
                <Trans>
                  I’m an AI powered assistant here to help you find solutions or
                  contact a human agent.
                </Trans>
              ),
              launchDarklyFlags,
              ...launchDarklyFlags.expWelcomePopupConfig,
            };
          }

          return {
            ...defaultPopUpConfig,
            title: <Trans>Get help</Trans>,
            text: <Trans>Find solutions or connect with an agent.</Trans>,
            launchDarklyFlags,
            ...launchDarklyFlags.expWelcomePopupConfig,
          };
      }
    };

    /*
     * Header render helpers
     */
    const renderBreadCrumbs = () => (
      <Breadcrumbs
        goToPrompt={this.goToPrompt}
        showPrompts={this.showPrompts}
        resetStates={this.resetStates}
      />
    );

    const renderHeaderText = () => {
      const {flowId} = siteData;
      return (
        <>
          {!isInProduct &&
            !expSalesBotAbTest &&
            !expEduAbTest &&
            !modernHeaderText && <Trans>GET HELP</Trans>}
          {isInProduct && (
            <>
              Autodesk Assistant
              <span className="beta-chip">
                <Trans>Beta</Trans>
              </span>
            </>
          )}
          {isInProduct && launchDarklyFlags.tempDiaryStudy && (
            <>
              <a
                href={`https://autodesk.com?flowId=${flowId}`}
                target="_blank"
                rel="noreferrer"
              >
                <span className="survey-chip">
                  <Trans>Survey</Trans>
                </span>
              </a>
            </>
          )}
          {(expSalesBotAbTest || expEduAbTest || modernHeaderText) && (
            <>
              <Trans>Autodesk Assistant</Trans>
            </>
          )}
        </>
      );
    };

    const renderHeader = () =>
      !showFullPageHeader ? (
        <Header
          onClose={this.handleToggle}
          onReload={this.handleReload}
          onBack={this.handleBack}
          showReloadAndBack={shouldShowSecondaryNav}
          showAvaConfirmModal={showAvaConfirmModal}
          title={renderHeaderText()}
          handleFail={this.handleFail}
          {...secButtonProps}
          componentShowingInUH={componentShowingInUH}
          showFullPage={showFullPage}
          siteData={siteData}
          currentGuid={currentGuid}
          userDetails={userDetails}
          componentData={componentData}
          updateUHComponentShowingNow={updateUHComponentShowingNow}
          showForm={showForm}
          toggleShowFeedbackWidgetFlow={toggleShowFeedbackWidgetFlow}
          showFeedbackWidgetFlow={showFeedbackWidgetFlow}
          requestId={requestId}
          avaLoading={avaLoading}
          contentSuggLoading={contentSuggLoading}
          avaConfirmAction={avaConfirmAction}
          closeAvaModal={closeAvaModal}
          lastComponentShown={lastComponentShown}
          lastComponentData={lastComponentData}
          openUHMThroughLink={openUHMThroughLink}
          contextualLinkOrigin={contextualLinkOrigin}
          isInProduct={isInProduct}
          hideHeader={
            isInProduct && ['NINVFUS', 'ACADMOBILE'].includes(siteData.product)
          }
          colorsToUpdate={colorsToUpdate}
          updateIsEndChatThroughButton={updateIsEndChatThroughButton}
          uhmSubHeaderType={uhmSubHeaderType}
          updateSaveChatTrigger={() => updateSaveChatTrigger()}
          endChat={this.handleEndChat}
          hideSubHeader={showOverlayComponent}
          showConversationalContainer={showConversationalContainer}
          expSalesBotAbTest={expSalesBotAbTest}
          expEduAbTest={expEduAbTest}
        />
      ) : (
        <FullPageHeader
          onBack={this.handleBack}
          showReloadAndBack={shouldShowSecondaryNav}
          componentShowingInUH={componentShowingInUH}
          renderBreadCrumbs={() => renderBreadCrumbs()}
        />
      );

    return (
      <div
        data-testid={`current-guid-${currentGuid}`}
        className={`${showFullPage ? 'widget--full-page' : 'widget'}${
          tempRosetta ? ' adsk-rosetta-theme' : ''
        }`}
      >
        {shouldRenderWindow && (
          <div
            className={
              windowIsClosing && launchDarklyFlags.tempAnimateMainWindow
                ? `${wrapperClasses} uhm-fade-out`
                : showMainWindow
                ? wrapperClasses
                : `${wrapperClasses} uhm-invisible`
            }
          >
            <div
              className={
                showFullPage
                  ? 'widget__window--full-page'
                  : `widget__window${addBackgroundColorForAvaFeedback}`
              }
            >
              {renderHeader()}
              {showConfirmModal && (
                <ConfirmModal
                  handleYes={() => this.handleConfirmModalAction('Yes')}
                  handleNo={() => this.handleConfirmModalAction('No')}
                  handleSaveChat={
                    confirmModalType !== 'restart' &&
                    (() => this.handleConfirmModalAction('SaveChat'))
                  }
                  title={
                    confirmModalType === 'restart' ? (
                      <Trans>Restart chat</Trans>
                    ) : (
                      <Trans>End chat</Trans>
                    )
                  }
                  body={
                    confirmModalType === 'restart' ? (
                      <Trans>
                        Do you want to clear the history and restart the chat?
                      </Trans>
                    ) : (
                      <Trans>
                        Are you sure you want to end this chat session?
                      </Trans>
                    )
                  }
                  confirmText={<Trans>Yes</Trans>}
                  rejectText={<Trans>No</Trans>}
                  // only show save chat link if the modal is to end chat (not restart), AND if a user initiated a live chat
                  saveChatText={
                    confirmModalType !== 'restart' &&
                    uhmSubHeaderType === 'chat' && (
                      <Trans>Save chat transcript</Trans>
                    )
                  }
                />
              )}
              <Suspense fallback={<LoadingSpinner />}>
                <ThemeMui>
                  <UniversalHelpBody
                    onSignIntoAnotherClick={this.handleSignIntoAnotherClick}
                    onGoToPrompt={this.handleNext}
                    fail={fail}
                    onFailError={this.handleFail}
                    onClose={this.handleToggle}
                    onReload={this.handleReload}
                    handleScrollTop={this.handleScrollTopImmediate}
                    closeAvaModal={closeAvaModal}
                    avaConfirmAction={avaConfirmAction}
                    resetStates={this.resetStates}
                    goToPrompt={this.goToPrompt}
                    hasCurrentChatSession={hasCurrentChatSession}
                    handleDeepLinks={this.handleDeepLinks}
                    handleConfirmModalAction={this.handleConfirmModalAction}
                    handleEndChat={this.handleEndChat}
                    handleConversationalRestart={
                      this.handleConversationalRestart
                    }
                  />
                </ThemeMui>
              </Suspense>
            </div>
          </div>
        )}
        <div
          data-testid="textAndTriggerContainer"
          className={showMainWindow ? `uhm-invisible` : ''}
        >
          {this.shouldRenderPopUp('showWelcomePopUp') ? (
            <PopupText
              onOpen={() => this.handlePopUpOpen('showWelcomePopUp')}
              onClose={() => this.handlePopUpClose('showWelcomePopUp')}
              popupType="welcome"
              {...getPopupTextOptions()}
            />
          ) : null}
          {this.shouldRenderPopUp('showContextualPopUp') ? (
            <PopupText
              onOpen={() => this.handlePopUpOpen('showContextualPopUp')}
              onClose={() => this.handlePopUpClose('showContextualPopUp')}
              primaryButtonText={<Trans>Yes, I do!</Trans>}
              secondaryButtonText={<Trans>No, thanks!</Trans>}
              onPrimaryClick={this.handleToggle}
              popupType="contextual"
              {...getPopupTextOptions('contextualPopUp')}
            />
          ) : null}
          <div
            style={{
              backgroundColor:
                colorsToUpdate.fabColor !== '' ? colorsToUpdate.fabColor : '',
            }}
            className={fabClass}
            onClick={() => {
              adpAnalyticsLog(
                buildAdpAnalyticsPayload({
                  e: 'uhm_icon_click',
                  ev: 'icon',
                  cm_cs_request_id: requestId
                })
              );
              this.handleToggle();
            }}
          >
            <FloatingActionButton isInProduct={isInProduct} />
          </div>
        </div>
      </div>
    );
  }
}

// Set default props
UniversalHelp.defaultProps = {
  startGuid: START_GUID,
};

// Set proptype rules
UniversalHelp.propTypes = {
  startGuid: PropTypes.string,
  utmSource: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    componentShowingInUH: state.uiOptions.componentShowingInUH,
    componentData: state.uiOptions.componentData,
    showMainWindow: state.uiOptions.showMainWindow,
    lastComponentShown: state.uiOptions.lastComponentShown,
    lastComponentData: state.uiOptions.lastComponentData,
    showReloadAndBack: state.uiOptions.showReloadAndBack,
    hideSecondaryNav: state.uiOptions.hideSecondaryNav,
    contactModalityShowing: state.uiOptions.contactModalityShowing,
    showConfirmModal: state.uiOptions.showConfirmModal,
    showForm: state.uiOptions.showForm,
    workflowData: state.workflowPrompts.workflowData,
    currentGuid: state.workflowPrompts.currentGuid,
    seenGuids: state.workflowPrompts.seenGuids,
    suggestedArticles: state.analytics.suggestedArticles,
    exceptionMsg: state.uiOptions.exceptionMsg,
    avaLoading: state.uiOptions.avaLoading,
    showAvaConfirmModal: state.uiOptions.showAvaConfirmModal,
    defaultEscapeActionGuid: state.workflowPrompts.defaultEscapeActionGuid,
    requestId: state.uiOptions.requestId,
    siteData: state.appSettings,
    currentTopLevelBranch: state.workflowPrompts.currentTopLevelBranch,
    currentPrompt: state.workflowPrompts.currentPrompt,
    disableNavbar: state.uiOptions.disableNavbar,
    fail: state.uiOptions.fail,
    popUpMainWindow: state.uiOptions.popUpMainWindow,
    hasUserInteracted: state.uiOptions.hasUserInteracted,
    openUHMThroughLink: state.uiOptions.openUHMThroughLink,
    contextualLinkOrigin: state.uiOptions.contextualLinkOrigin,
    showContactFooter: state.workflowPrompts.showContactFooter,
    defaultSupportSkill: state.workflowPrompts.defaultSupportSkill,
    sfdcType: state.workflowPrompts.sfdcType,
    sfdcTopic: state.workflowPrompts.sfdcTopic,
    resolvedSfdcType: state.workflowPrompts.resolvedSfdcType,
    resolvedSfdcTopic: state.workflowPrompts.resolvedSfdcTopic,
    resolvedSkill: state.workflowPrompts.resolvedSkill,
    premiumSupportSkill: state.workflowPrompts.premiumSupportSkill,
    premiumSfdcType: state.workflowPrompts.premiumSfdcType,
    premiumSfdcTopic: state.workflowPrompts.premiumSfdcTopic,
    productsReleases: state.workflowPrompts.productsReleases,
    disabledModalities: state.uiOptions.disabledModalities,
    userEntitlements: state.userData.userEntitlements,
    userDetails: state.userData.userDetails,
    userContext: state.workflowPrompts.userContext,
    showFeedbackWidgetFlow: state.uiOptions.showFeedbackWidgetFlow,
    avaConfirmAction: state.uiOptions.avaConfirmAction,
    goToAfterConfirm: state.uiOptions.goToAfterConfirm,
    isFeedbackWidgetMounted: state.uiOptions.isFeedbackWidgetMounted,
    resetToHome: state.uiOptions.resetToHome,
    contentSuggestionFlowRef: state.uiOptions.contentSuggestionFlowRef,
    loginHappening: state.userData.loginHappening,
    defaultProduct: state.appSettings.productDetails,
    selectedProduct: state.uiOptions.selectedProduct,
    contentSuggestionInput: state.uiOptions.contentSuggestionInput,
    selectedVersion: state.uiOptions.selectedVersion,
    containerEventMessage: state.uiOptions.containerEventMessage,
    colorsToUpdate: state.uiOptions.colorsToUpdate,
    isEndChatThroughButton: state.uiOptions.isEndChatThroughButton,
    uhmSubHeaderType: state.uiOptions.uhmSubHeaderType,
    utmSource: state.appSettings.utmSource,
    showOverlayComponent: state.uiOptions.showOverlayComponent,
    hasInstructionalText: state.uiOptions.hasInstructionalText,
    endChatTrigger: state.uiOptions.endChatTrigger,
    showAgentAvailabilityFallbackComponent:
      state.uiOptions.showAgentAvailabilityFallbackComponent,
    isAnythingElseEndChat: state.uiOptions.isAnythingElseEndChat,
    confirmModalType: state.uiOptions.confirmModalType,
    isChatActive: state.uiOptions.isChatActive,
    openAfterRedirect: state.uiOptions.openAfterRedirect,
    viewingArticle: state.appSettings.viewingArticle,
  };
};

export default withLDConsumer()(
  connect(mapStateToProps, {
    updateHeaderReloadAndBack,
    updateUHComponentShowingNow,
    updateContentSuggUserInput,
    updateSelectedProduct,
    updateSelectedVersion,
    toggleUserInput,
    fetchWorkflow,
    fetchProductReleases,
    updateCurrentGuid,
    updateHasBeedRedirected,
    updateSeenGuids,
    toggleMainWindowAndFab,
    updateCurrentPrompt,
    updateSkillsResponse,
    updateSuggestedArticles,
    updateSuggestedArticleType,
    updateExceptionMsg,
    updateDefaultSupportSkill,
    updateResolvedSupportSkill,
    updateSfdcType,
    updateSfdcTopic,
    updatePremiumSupportSkill,
    updatePremiumSfdcType,
    updatePremiumSfdcTopic,
    toggleAvaLoading,
    showAvaModal,
    closeAvaModal,
    updateShowContactFooter,
    updateDefaultEscapeActionGuid,
    updateShowContactDetailsInAction,
    updateHideTopicNotListed,
    updateHideContactModalities,
    updateShowResellerContactModality,
    updateCurrentTopLevelBranch,
    disableNavBtns,
    togglePopUpMainWindow,
    toggleLoginHappening,
    updateContactAppLoading,
    quickToggleShowPhoneFooter,
    toggleShowFeedbackWidgetFlow,
    updateUserContext,
    updateShowModal,
    updateHideSecondaryNav,
    updateShowAdditionalQuestionsPage,
    updateOpenUHMThroughLink,
    updateContextualLinkOrigin,
    updatelinkToADNSupportPage,
    updateResetToHome,
    updateIsChatActive,
    updateIsEndChatThroughButton,
    updateUhmSubHeaderType,
    updateSaveChatTrigger,
    updateSettingsSiteData,
    updateEndChatTrigger,
    updateShowOverlayComponent,
    updateHasInstructionalText,
    updateUserInputFromAva,
    // updateShowAgentAvailabilityComponent,
    updateShowAgentAvailabilityFallbackComponent,
    updateShowAnythingElseComponent,
    updateShowPhoneHourBubbleComponent,
    updateAnythingElseEndChat,
    updateSubOrigin,
    updateUserInteracted,
    updateDeepLinkCAEduFlow,
    updateContainerEventMessage,
    updateOpenAferRedirect,
    updateRequestId,
    updateSessionTokenAvailable
  })(UniversalHelp)
);
